// libs/router/useRouterCompat.ts
"use client";

// TODO: THIS IS A TEMPORARY FILE TO HELP WITH THE MIGRATION TO NEXT.JS APP ROUTER.

import {
  useRouter as useNextRouter,
  usePathname,
  useSearchParams
} from "next/navigation";

type QueryValue = string | string[];
type Query = Record<string, QueryValue>;

type NavigateOptions = { scroll?: boolean; shallow?: boolean };

// Oggetto stile "next/router" (semplificato)
type UrlObject = {
  pathname: string;
  query?: Record<string, string | string[]>;
};

type Url = string | UrlObject;

type LegacyRouter = {
  push: (url: Url, as?: string, options?: NavigateOptions) => void;
  replace: (url: Url, as?: string, options?: NavigateOptions) => void;
  prefetch: (url: string) => Promise<void>;
  back: () => void;
  forward: () => void;
  reload: () => void;
  pathname: string;
  asPath: string;
  query: Query;
  events: {
    on: (..._args: any[]) => void;
    off: (..._args: any[]) => void;
  };
  isReady: boolean;
};

function buildQuery(params: URLSearchParams): Query {
  const q: Query = {};
  params.forEach((value, key) => {
    if (q[key] === undefined) {
      const all = params.getAll(key);
      q[key] = all.length > 1 ? all : value;
    } else if (Array.isArray(q[key])) {
      (q[key] as string[]).push(value);
    } else {
      q[key] = [q[key] as string, value];
    }
  });
  return q;
}

function toSearchParams(
  query?: Record<string, string | string[]>
): URLSearchParams {
  const sp = new URLSearchParams();
  if (!query) return sp;

  for (const [key, value] of Object.entries(query)) {
    if (Array.isArray(value)) {
      for (const v of value) sp.append(key, String(v));
    } else if (value !== undefined) {
      sp.set(key, String(value));
    }
  }
  return sp;
}

function toUrl(url: Url): string {
  if (typeof url === "string") return url;

  const sp = toSearchParams(url.query);
  const qs = sp.toString();
  return qs ? `${url.pathname}?${qs}` : url.pathname;
}

export const useRouter = (): LegacyRouter => {
  const router = useNextRouter();
  const pathname = usePathname() || "";
  const searchParams = useSearchParams();

  const search = searchParams?.toString() || "";
  const asPath = search ? `${pathname}?${search}` : pathname;
  const query = buildQuery(searchParams ?? new URLSearchParams());

  return {
    push: (url, _as, options) =>
      router.push(toUrl(url), { scroll: options?.scroll }),

    replace: (url, _as, options) =>
      router.replace(toUrl(url), { scroll: options?.scroll }),

    prefetch: async (_url: string) => Promise.resolve(),

    back: () => router.back(),

    forward: () => {
      if (typeof window !== "undefined") window.history.forward();
    },

    reload: () => router.refresh(),

    pathname,
    asPath,
    query,

    events: {
      on: () => {},
      off: () => {}
    },

    isReady: true
  };
};
